module.exports = __webpack_public_path__ + "static/media/new_watch_playlist.a7349b51.svg";